import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumWeightUnit implements BaseEnumType {
  private static allValues: EnumWeightUnit[] = []; // make sure this is top-most
  
  public static none = new EnumWeightUnit(0, "None", "enum_weight_unit_none");
  public static metricGram = new EnumWeightUnit(1, "MetricGram", "enum_weight_unit_metric_gram");
  public static metricKilogram = new EnumWeightUnit(2, "MetricKilogram", "enum_weight_unit_metric_kilogram");
  public static metricTonne = new EnumWeightUnit(3, "MetricTonne", "enum_weight_unit_metric_tonne");
  public static usImperialOunce = new EnumWeightUnit(21, "UsImperialOunce", "enum_weight_unit_us_imperial_ounce");
  public static usImperialPound = new EnumWeightUnit(22, "UsImperialPound", "enum_weight_unit_us_imperial_pound");
  public static usImperialTon = new EnumWeightUnit(23, "UsImperialTon", "enum_weight_unit_us_imperial_ton");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumWeightUnit.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumWeightUnit.none; }
  public isMetricGram() { return this === EnumWeightUnit.metricGram; }
  public isMetricKilogram() { return this === EnumWeightUnit.metricKilogram; }
  public isMetricTonne() { return this === EnumWeightUnit.metricTonne; }
  public isUsImperialOunce() { return this === EnumWeightUnit.usImperialOunce; }
  public isUsImperialPound() { return this === EnumWeightUnit.usImperialPound; }
  public isUsImperialTon() { return this === EnumWeightUnit.usImperialTon; }

  public static getValues(): readonly EnumWeightUnit[] {
    return EnumWeightUnit.allValues;
  }

  public static getValuesExcept0(): readonly EnumWeightUnit[] {
    return EnumWeightUnit.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumWeightUnit {
    const found = EnumWeightUnit.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumWeightUnit - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumWeightUnit): EnumWeightUnit {
    const found = name ? EnumWeightUnit.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumWeightUnit - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumWeightUnit>): boolean {
    return this.key === other?.key;
  }
}